export default "__VITE_ASSET__44a21e47__"